import React from 'react';
import { motion } from 'framer-motion';
import { InteriorSlide, SlideHeader, SlideBanner } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide08Scale({
  index
}: SlideProps) {
  return <InteriorSlide surface banner={<SlideBanner eyebrow="Simple Pricing" data-id="element-187">
          €6,500 per brand: 4 campaigns
        </SlideBanner>} data-id="element-186">
      <SlideHeader eyebrow="Annual Partnership" data-id="element-188">
        Simple Pricing Breakdown
      </SlideHeader>

      <div className="flex-1 flex flex-col max-w-5xl mx-auto w-full gap-8" data-id="element-189">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-190">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="bg-white rounded-2xl shadow-sm border border-black/5 p-8 flex flex-col" data-id="element-191">
            <div className="text-sm font-bold text-[var(--muted)] uppercase tracking-wider mb-2" data-id="element-192">
              1x Master Snak
            </div>
            <div className="text-4xl font-extrabold text-[var(--fg)] mb-4" data-id="element-193">
              €2,500
            </div>
            <p className="text-[var(--muted)] leading-relaxed" data-id="element-194">
              Once-off Master Snak creation and campaign scoping.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="bg-white rounded-2xl shadow-sm border border-black/5 p-8 flex flex-col" data-id="element-195">
            <div className="text-sm font-bold text-[var(--muted)] uppercase tracking-wider mb-2" data-id="element-196">
              4x Campaigns
            </div>
            <div className="text-4xl font-extrabold text-[var(--fg)] mb-4" data-id="element-197">
              €4,000
            </div>
            <p className="text-[var(--muted)] leading-relaxed" data-id="element-198">
              4 × €1,000 per campaign adaptation.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="bg-[var(--surface)] rounded-2xl p-8 border border-black/5 mt-4" data-id="element-199">
          <h3 className="text-lg font-bold text-[var(--fg)] mb-6" data-id="element-200">
            First campaign ideas:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-201">
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-202">
              <p className="font-semibold text-[var(--fg)]" data-id="element-203">
                Compliant non-branded WhatsApp campaign
              </p>
              <p className="text-sm text-[var(--muted)] mt-2" data-id="element-204">
                (where applicable)
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-205">
              <p className="font-semibold text-[var(--fg)]" data-id="element-206">
                Patient or medical association campaign
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-207">
              <p className="font-semibold text-[var(--fg)]" data-id="element-208">Branded campaign</p>
              <p className="text-sm text-[var(--muted)] mt-2" data-id="element-209">
                (Snakker recommends based on data)
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </InteriorSlide>;
}